<template>
    <div class="teachingTable w100 pl20 pr20 pt20 pb20" v-loading="loading">
      <div style="width: 100%;text-align: center;font-size: 18px;font-weight: bold;">教学评教</div>
      <div style="display: flex; justify-content: end">
        <el-select
            style="width: 200px; margin: 0 10px"
            v-model="paramSearch.semesterId" placeholder="请选择学期">
            <el-option
                    v-for="item in semesterList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <el-input v-model="paramSearch.courseName" placeholder="请输入课程名称" style="width: 200px;" class="mr20"></el-input>
        <el-button type="primary" @click="initPage">查询</el-button>
      </div>

        <div class="table-con">
            <el-table class="w100 mt20 table" header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list" >
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="课程名称"></el-table-column>
                <el-table-column align="center" prop="teachers" label="教师名字"></el-table-column>
                <el-table-column align="center" prop="pkteachclassname" label="授课班级" width="180"></el-table-column>
                <el-table-column align="center" prop="date" label="上课日期"></el-table-column>
                <el-table-column align="center" prop="day" label="星期" :formatter="formatDay"></el-table-column>
                <el-table-column align="center" prop="knob" label="课程节次" :formatter="knobFormat"></el-table-column>
                <el-table-column align="center" label="签到状态" :formatter="statusFormat"></el-table-column>
                <!-- <el-table-column align="center" prop="name" label="课堂评分"></el-table-column> -->
                <el-table-column align="center" prop="learnEffect" label="学习效果"></el-table-column>
                <el-table-column align="center" prop="interaction" label="师生互动"></el-table-column>
                <el-table-column align="center" prop="personalAbility" label="个人能力提升"></el-table-column>

                <el-table-column align="center" prop="refuseIP" label="操作">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="toDetail(scope.row)">详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                  @current-change="changePage"
                  :current-page="paramSearch.current"
                  :page-sizes="pageSizes"
                  :page-size="paramSearch.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
            ></el-pagination>
        </div>
        
        <!-- 详情弹窗 -->
        <el-dialog
          title="课堂详情"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          width="80%"
          :append-to-body=true
          >
          <div>
            <Evaluation
            :info="detailInfo"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from '@/api/overseasChinese/overseasChinese'
    import Evaluation from "./evaluation/index.vue"
    export default {
        name: "Special",
        props: [],
        components:{
          Evaluation
        },
        data() {
            return {
                semesterList: [],
                loading: false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    courseName:'',
                    semesterId: ''
                },
                total: 0,
                dialogVisible:false,
                detailInfo:""
            };
        },
        computed: {},
        created() {
          this.getSemesterData()
        },
        methods: {
           getSemesterData() {
                api.getSemesterSel().then(({data}) => {
                    this.semesterList = data.data
                    let arr = data.data.find((item) => item.current == 1) || data.data[0]
                    this.paramSearch.semesterId = arr.id
                    this.getList()
                })
            },
            // 获取查询列表
            getList() {
              this.loading = true
              api.selectPCAttendance(this.paramSearch).then(res=> {
                this.loading = false
                if(res.data.code == 0) {
                  this.list = res.data.data.records || []
                  this.total = res.data.data.total
                }
              })
              .catch(() => {
                this.loading = false
              })
          },
            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    current:1,
                }
                this.getList();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getList();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getList();
            },
            statusFormat(row) {
              let status = row.status
              switch(status) {
                case '1':
                  return  '正常'
                case '2':
                  return '迟到'
                case '3':
                  return '早退'
                case '4':
                  return'缺勤'
                case '5':
                  return '补卡待审核'
                default:
                  return "";
              }
            },
            formatDay(row) {
                switch(row.day) {
                  case '1':
                    return '星期一'
                  case '2':
                    return '星期二'
                  case '3':
                    return '星期三'
                  case '4':
                    return '星期四'
                  case '5':
                    return '星期五'
                  case '6':
                    return '星期六'
                  case '7':
                    return '星期天'
                  default:
                    return "";
                }
            },
            knobFormat(row) {
              return row.knob + '节次'
            },
            toDetail(info) {
              this.dialogVisible=true;
              this.detailInfo = info;
              // this.$router.push({
              //   path: '/evaluation',
              //   query: {
              //     info: JSON.stringify(info),
              //   }
              // })
            }
        },
        watch: {},
        filters: {}
    };
</script>


<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    .search-warp{
        height:40px ;
    }
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
    .teachingTable {
      width: 100%;
      height: calc(100vh - 69px) !important;
      overflow: auto !important;
      background: #fff;
    }
</style>
